module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/sd-cb3da007630d3b35d1ca521bb2c76364.svg";